module.exports = __webpack_public_path__ + "media/images/pc/brands/sola/store_hokkaido@2x-81911f38014d00d4d1242250937b3cfa.webp";